import { requestV2 } from '../common/utils';
export const getPlacesByDistrictApi = (districtId) => requestV2({
    url: `/places/district/${districtId}`,
    method: 'GET',
});
export const getPlacesApi = (params, signal) => requestV2({
    url: '/places/map',
    method: 'GET',
    params,
    signal,
});
export const getPlacesByProjectApi = (projectId) => requestV2({
    url: `/places/project/${projectId}`,
    method: 'GET',
});
export const getPlacesCategoriesApi = () => requestV2({
    url: '/places/categories',
    method: 'GET',
});
export const getPlacesCategoryApi = (id) => requestV2({
    url: `/places/categories/${id}`,
    method: 'GET',
});
export const getPlaceApi = (id) => requestV2({
    url: `/places/${id}`,
    method: 'GET',
});
export const createPlacesCategoryAdminApi = (data) => requestV2({
    url: '/places/categories',
    method: 'POST',
    headers: { 'x-api-scope': 'admin' },
    data,
});
export const editPlacesCategoryAdminApi = (id, data) => requestV2({
    url: `/places/categories/${id}`,
    method: 'PATCH',
    data,
    headers: { 'x-api-scope': 'admin' },
});
export const deletePlacesCategoryAdminApi = (id) => requestV2({
    url: `/places/categories/${id}`,
    method: 'DELETE',
    headers: { 'x-api-scope': 'admin' },
});
export const getPlacesDashBoardAdminApi = (params, signal) => requestV2({
    url: '/places/dashboard',
    method: 'GET',
    params,
    signal,
    headers: { 'x-api-scope': 'admin' },
});
export const getPlaceDashboardAdminApi = (id) => requestV2({
    url: `/places/dashboard/place/${id}`,
    method: 'GET',
    headers: { 'x-api-scope': 'admin' },
});
export const deletePlacesAdminApi = (id) => requestV2({
    url: `/places/${id}`,
    method: 'DELETE',
    headers: { 'x-api-scope': 'admin' },
});
export const createPlaceAdminApi = (data) => requestV2({
    url: '/places',
    method: 'POST',
    data,
    headers: { 'x-api-scope': 'admin' },
});
export const editPlaceAdminApi = (id, data) => requestV2({
    url: `/places/${id}`,
    method: 'PATCH',
    data,
    headers: { 'x-api-scope': 'admin' },
});
